import React, { useMemo } from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import CalendarTimeGrid from "../../CalendarTimeGrid"

const Day = ({ date, experienceIds, crewIds, equipmentIds, categoryIds, activeTab, startHour, endHour, showTimeRangeSettings, onStartHourChange, onEndHourChange, onResetHours, onOpenDayPanel }) => {
  const { bookings } = useSelector((state) => state.calendar)
  const allExperiences = useSelector((state) => state.experiences?.list || [])

  const events = useMemo(() => {
    return bookings?.map((booking) => ({
      id: booking?.uuid,
      booking_id: booking?.id,
      blackout_conflict: booking?.blackout_conflict,
      start: booking?.start_time,
      end: booking?.end_time,
      title: booking?.client_name,
      date: booking?.date,
      payment_status: booking?.payment_status,
      booking_status: booking?.booking_status,
      resource: booking?.experience_name,
      experienceName: booking?.experience_name,
      experience_id: booking?.experience_id,
      assigned_crew: booking?.assigned_crew || [],
      assigned_equipment: booking?.assigned_equipment || [],
      color: booking?.color,
      multi_day: booking?.multi_day,
      client_name: booking?.client_name,
      adult_count: booking?.adult_count,
      child_count: booking?.child_count,
      infant_count: booking?.infant_count,
      location: booking?.location,
      is_waiver_attached: booking?.is_waiver_attached,
      signed_waiver_count: booking?.signed_waiver_count,
      total_guest_count: booking?.total_guest_count,
      max_guests: booking?.max_guests,
      booked_dates: booking?.booked_dates,
    }))
  }, [bookings])

  const resources = useMemo(() => {
    if (crewIds?.length > 0 || equipmentIds?.length > 0) {
      const encounteredIds = new Set()
      return events
        .filter((ev) => {
          if (!ev.experience_id || encounteredIds.has(ev.experience_id)) return false
          encounteredIds.add(ev.experience_id)
          return true
        })
        .map((ev) => ({ id: ev.experience_id, title: ev.resource }))
    }
    if (experienceIds?.length > 0) {
      return allExperiences
        .filter((exp) => experienceIds.includes(exp.id))
        .map((exp) => ({ id: exp.id, title: exp.title }))
    }
    return allExperiences.map((exp) => ({ id: exp.id, title: exp.title }))
  }, [allExperiences, events, experienceIds, crewIds, equipmentIds])

  return (
    <CalendarTimeGrid
      date={date}
      events={events}
      type="day"
      resources={resources}
      crewIds={crewIds}
      equipmentIds={equipmentIds}
      categoryIds={categoryIds}
      activeTab={activeTab}
      startHour={startHour}
      endHour={endHour}
      showTimeRangeSettings={showTimeRangeSettings}
      onStartHourChange={onStartHourChange}
      onEndHourChange={onEndHourChange}
      onResetHours={onResetHours}
      onOpenDayPanel={onOpenDayPanel}
    />
  )
}

Day.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  experienceIds: PropTypes.array,
  crewIds: PropTypes.array,
  equipmentIds: PropTypes.array,
  activeTab: PropTypes.string,
  startHour: PropTypes.number,
  endHour: PropTypes.number,
  showTimeRangeSettings: PropTypes.bool,
  onStartHourChange: PropTypes.func,
  onEndHourChange: PropTypes.func,
  onResetHours: PropTypes.func,
  onOpenDayPanel: PropTypes.func,
}

export default Day
